import React from 'react';
import AlertDialog from '../../dialog/AlertDialog';

const ThanksForSubscribingDialog = () =>
    (<AlertDialog
        title="Your subscription will be completed soon">
        <p>You can check the status of your subscription in the License Settings page.</p>
    </AlertDialog>);

export default ThanksForSubscribingDialog;